import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
// --- external imports -----

import { uiSelectors, uiActions } from '~/store';
// --- internal imports -----

function EscapeKeyHandler({ activeComponent, gameMenuReturnRoute, setGameMenuReturnRoute }) {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (event.key !== 'Escape') {
				return;
			}

			// Don't handle escape in tradeshow (time critical)
			if (location.pathname === '/game/tradeshow') {
				return;
			}

			// If game menu is currently active, navigate back to previous route
			if (activeComponent === 'game_menu') {
				navigate(gameMenuReturnRoute || '/game/game-user');
			} else {
				// Store current route and navigate to game menu
				setGameMenuReturnRoute(location.pathname);
				navigate('/game/game-menu');
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [activeComponent, gameMenuReturnRoute, location.pathname, navigate, setGameMenuReturnRoute]);

	return null;
}

function mapStateToProps(state) {
	return {
		activeComponent: uiSelectors.getCurrentActiveComponentName(state),
		gameMenuReturnRoute: uiSelectors.getGameMenuReturnRoute(state),
	};
}

const mapDispatchToProps = {
	setGameMenuReturnRoute: uiActions.setGameMenuReturnRoute,
};

export default connect(mapStateToProps, mapDispatchToProps)(EscapeKeyHandler);

